/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';
    
    export interface IVideoFeed {
        status: VideoFeedStatus;
        videoUrl: string;
        thumbnailUrl: string;
        position: PipePosition;
        blockTypeNaturalKey: string;
        forceRefreshThumbnail: boolean;
        properThumbnail: boolean;
        properVideo: boolean;
        properBitrateTrending: boolean;
        IsEmpty(): boolean;
    }

    export class VideoFeed implements IVideoFeed {
        public status: VideoFeedStatus;
        public videoUrl: string;
        public thumbnailUrl: string;
        public position: PipePosition;
        public blockTypeNaturalKey: string;
        public forceRefreshThumbnail: boolean;
        public properThumbnail: boolean;
        public properVideo: boolean;
        public properBitrateTrending: boolean;

        public static Empty(): VideoFeed {
            return new VideoFeed();
        }

        public static setThumbnailPerStatus(videoFeed: IVideoFeed): string {
            // tODO: some cleanup here, please!
            if (videoFeed.thumbnailUrl !== '') {
                if (videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.MVP_CLIENT ||
                    videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.MVP_PLAYOUT ||
                    videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.MVP_EXPORT ||
                    videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.MVP_SERVER) {
                    // this is a bit hacky, but can't see how improve it
                    videoFeed.thumbnailUrl = window.backendUrl + "mvpadapter" + videoFeed.thumbnailUrl;
                } else {
                    videoFeed.thumbnailUrl = window.backendUrl + videoFeed.thumbnailUrl;
                }

                // remote images are always refreshed
                videoFeed.forceRefreshThumbnail = true;
                return videoFeed.thumbnailUrl;
            } else if (videoFeed.thumbnailUrl === '' && videoFeed.status === VideoFeedStatus.OK ) {
                    switch ( videoFeed.blockTypeNaturalKey ) {
                        case BlockTypeNaturalKey.IKUSNET_QUAD_TS:
                            return 'images/thumbnail-ikusnet-connected.png?';
                        case BlockTypeNaturalKey.SDI_DESTINATION:
                            return 'images/thumbnail-sdi-idle.png';
                        default:
                            return 'images/thumbnail-no-thumb.png?';
                    }
            } else if (videoFeed.status === VideoFeedStatus.OFFLINE) {
                // console.log("OFFLINE");
                return 'images/thumbnail-offline.png?';
            } else if (videoFeed.status === VideoFeedStatus.SERVER_NOT_AVAILABLE) {
                // console.log("SNA");
                return 'images/thumbnail-server-not-available.png?';
            } else if (videoFeed.status === VideoFeedStatus.CONNECTING) {
                if (videoFeed.position === PipePosition.SINK) {
                    if (videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.ATEME_DR5000) { 
                        return 'images/thumbnail-ateme-dr5000-idle.png?'; 
                    } else if (videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.MEDIAKIND_RX8200) {
                        return 'images/thumbnail-ericsson-rx8200-idle.png?'; 
                    } else if (videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.IKUSNET_QUAD_TS) {
                        return 'images/thumbnail-ikusnet-quad-idle.png?';
                    } else if (videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.T9261_D) {
                        return 'images/thumbnail-ts-idle.png';
                    }  else if (videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.V_TS_DESTINATION) {
                        return 'images/thumbnail-ts-idle.png';
                    } else {
                        return 'images/thumbnail-playout-idle.png?';
                    }
                } else
                    return 'images/thumbnail-connecting.png?';
            } else if (videoFeed.status === VideoFeedStatus.DISCONNECTING) {
                if (videoFeed.position === PipePosition.SINK)
                    return 'images/thumbnail-playout-idle.png?';
                else
                    return 'images/thumbnail-disconnecting.png?';
            } else if (videoFeed.status === VideoFeedStatus.READY) {
                if (videoFeed.position === PipePosition.SINK) {
                    if (videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.ATEME_DR5000) {
                        return 'images/thumbnail-ateme-dr5000-idle.png?';
                    } else if (videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.ATEME_CM5000) {
                        return 'images/thumbnail-ateme-dr5000-idle.png?';
                    } else if (videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.MEDIAKIND_RX8200) {
                        return 'images/thumbnail-ericsson-rx8200-idle.png?';
                    } else if (videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.IKUSNET_QUAD_TS) {
                        return 'images/thumbnail-ikusnet-quad-idle.png?';
                    } else if (videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.T9261_D) {
                        return 'images/thumbnail-ts-idle.png';
                    } else if (videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.V_TS_DESTINATION) {
                        return 'images/thumbnail-ts-idle.png';
                    } else if (videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.SDI_DESTINATION) {
                        return 'images/thumbnail-sdi-idle.png';
                    } else if (videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.VIRT_SRT_RX_LSTN) {
                        return 'images/thumbnail-ready.png';
                    }else {
                        return 'images/thumbnail-playout-idle.png?';
                    }
                } else {
                    if (videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.V_TS) {
                        return 'images/thumbnail-ts-idle.png?';
                    } else if (videoFeed.blockTypeNaturalKey === BlockTypeNaturalKey.SDI_DESTINATION) {
                        return 'images/thumbnail-sdi-idle.png';
                    }  else {
                        return 'images/thumbnail-ready.png?';
                    }
                }
            }

    }

        constructor() {
            // empty constructor
            this.status = VideoFeedStatus.ERROR;
            this.videoUrl = '';
            this.thumbnailUrl = '';
            this.position = PipePosition.NONE;
            this.blockTypeNaturalKey = '';
            this.forceRefreshThumbnail = false;
        }

        public IsEmpty(): boolean {
            return (this.videoUrl === '' && this.thumbnailUrl === '');
        }

        public equals(videoFeed: IVideoFeed): boolean {
            return videoFeed !== undefined &&
                this.status === videoFeed.status &&
                this.thumbnailUrl === videoFeed.thumbnailUrl &&
                this.videoUrl === videoFeed.videoUrl &&
                this.position === videoFeed.position &&
                this.blockTypeNaturalKey === videoFeed.blockTypeNaturalKey;
        }
    }

    export class VideoFeedStatus {
        public static OK: string = "OK";
        public static SERVER_NOT_AVAILABLE: string = "SERVER_NOT_AVAILABLE";
        public static CONNECTING: string = "CONNECTING";
        public static DISCONNECTING: string = "DISCONNECTING";
        public static READY: string = "READY";
        public static OFFLINE: string = "OFFLINE";
        public static ERROR: string = "ERROR";
    }

    export class PipePosition {
        public static NONE: string = "NONE";
        public static SOURCE: string = "SOURCE";
        public static SINK: string = "SINK";
    }
}